<div class="inmodal modal-lg" sharedUiModalFocusInput>
  <div class="modal-header py-3">
    <h4 class="modal-title text-center full-width" id="modal-title">
      <span *ngIf="hasIcon">
        <shared-ui-icons-icon [iconName]="IconType.Mobile" class="d-inline-flex"></shared-ui-icons-icon>
        <br />
      </span>
      {{ title }}
    </h4>
    <shared-ui-buttons-button
      [icon]="IconType.Xmark"
      *ngIf="hasXButton"
      [type]="ButtonType.DefaultText"
      (action)="activeModal.close()"
      class="position-absolute top-0 end-0 m-3"
    ></shared-ui-buttons-button>
  </div>
  <hr class="mt-0" />
  <div *ngIf="hasBody" class="modal-body bg-white">
    <ng-content></ng-content>
  </div>
  <div class="modal-footer gap-2 mt-2">
    <shared-ui-buttons-button *ngIf="canCancel" [text]="cancelButtonTitle" [type]="cancelButtonType" (action)="activeModal.close()"></shared-ui-buttons-button>
    <shared-ui-buttons-button *ngIf="canConfirm && hasBrowseButton" [text]="'Browse'" [type]="ButtonType.DefaultOutline" (action)="browseOutput()"></shared-ui-buttons-button>
    <shared-ui-buttons-button
      *ngIf="hasRetryButton"
      [text]="retryButtonTitle"
      [type]="ButtonType.Primary"
      [disabled]="disableAllButtons"
      (action)="retryAction()"
    ></shared-ui-buttons-button>
    <shared-ui-buttons-button
      *ngIf="canConfirm"
      [disabled]="confirmButtonDisabled || disableAllButtons"
      [text]="confirmButtonTitle"
      [type]="confirmButtonType"
      [icon]="confirmButtonIcon"
      (action)="confirmClose()"
    ></shared-ui-buttons-button>
    <shared-ui-buttons-button
      *ngIf="canConfirm && useSecondButton"
      [disabled]="confirmButtonDisabled || disableAllButtons"
      [text]="confirmSecondButtonTitle"
      [type]="confirmButtonType"
      (action)="confirmCloseSecondButton()"
    ></shared-ui-buttons-button>
    <shared-ui-buttons-button-copy-to-clipboard
      *ngIf="hasCopyButton && !canConfirm"
      [icon]="IconType.Copy"
      [type]="ButtonType.DefaultOutline"
      [textToCopy]="textToCopy"
    ></shared-ui-buttons-button-copy-to-clipboard>
  </div>
</div>
